module.exports = __webpack_public_path__ + "static/food-blog-mobile-plp-6ccc502033db7a58342b2ef869c4b629.jpeg";